module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/7-5110581ff6c5de16a737aa8c0393e0b6.jpg";